import {
    observable,
    action,
    computed,
    when,
    reaction,
} from 'mobx';

import { myConst, myMap } from "@/config/";
import { loadingEnd } from "@/utils/ui";
import { toggleInfoBox } from "@/components/Map/utils/infoBox";


export default class AppStore {
    constructor(rootStore) {
        this.rootStore = rootStore;
        if (localStorage.UseOrEmpty) {
            this.appState.UseOrEmpty = localStorage.UseOrEmpty.toString() === "true" ? true : false;
        }
        when(() => this.initComplete, () => {
            console.green('watch 到全部 ok 啦');
            loadingEnd();
        });

        // watchLoc
        reaction(() => this.locState.watchLoc, watchLoc => {
            let id = this.locState.watchLocId;
            if (watchLoc) {
                console.red('开始监听定位');
                clearInterval(id);
                myMap.geolocation.getLoc();
                this.locState.watchLocId = setInterval(() => {
                    myMap.geolocation.getLoc();
                }, myConst.loc.watchCycle);
            } else {
                console.red('停止监听定位');
                clearInterval(id);
            }
        }, { name: 'watchLoc' });
        // fireImmediately: true

    }

    @observable initState = {
        page: false,
    }

    @observable locState = {
        isLocIng: false, // 是否正在定位
        succLoc: false,
        watchLoc: false,
        watchLocId: 0,
    }
    @observable appState = {
        UseOrEmpty: false, // true 显示空位
        devMode: false,
        searchShow: false,
    }

    @computed get initComplete() {
        return this.initState.page;
    }
    @action.bound firstPageIsOk() {
        this.initState.page = true;
    }

    @action.bound changeWatchLoc() {
        this.locState.watchLoc = !this.locState.watchLoc;
        window.mdui.snackbar({ message: `${this.locState.watchLoc ? "开始" : "停止"}监听定位`, timeout: 1000, position: "right-top" });
    }
    @action.bound changeIsLocIng(options) {
        // 定位成功
        this.locState.isLocIng = options;
    }

    @action.bound changeLocState(options) {
        // 定位成功
        this.locState.succLoc = options;
    }

    @action.bound toggleSearchShow(on_off) {
        if (on_off === undefined) {
            this.appState.searchShow = !this.appState.searchShow;
        } else {
            this.appState.searchShow = on_off;
        }
        if (this.appState.searchShow) {
            toggleInfoBox({ on_off: false, source: 'toggleSearch' });
            $$(".BMap_noprint.anchorTR").removeClass("hide");
            $$("#search .his_item.delete").removeClass("delete");
        } else {
            $$(".BMap_noprint.anchorTR").removeClass("hide");
        }
    }
    @action.bound toggleDevMode(options) {
        if (!options) {
            this.appState.devMode = !this.appState.devMode;
        } else {
            this.appState.devMode = options.on_off;
        }
    }
    @action.bound toggleUseOrEmpty(options) {
        this.appState.UseOrEmpty = options.value;
        localStorage.UseOrEmpty = options.value;
    }
}
